var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.show)?_c('div',{ref:"wxc-overlay",staticClass:"wxc-overlay",style:(_vm.overlayStyle),attrs:{"hack":_vm.shouldShow},on:{"click":_vm.overlayClicked}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }